import * as React from 'react';
import type { ReactNode } from 'react';

import type { HeaderLevel } from 'bundles/cds-labs/components/Modules/CollectionsModule';
import { headerOrder } from 'bundles/cds-labs/components/Modules/CollectionsModule';
import { HeaderLevelContext } from 'bundles/page-config-common/contexts/HeaderLevelContext';

const HeaderLevelProvider = ({
  initialLevel = 'h2',
  children,
}: {
  initialLevel?: HeaderLevel;
  children: ReactNode;
}) => {
  const nextLevel = headerOrder[Math.min(headerOrder.indexOf(initialLevel) + 1, headerOrder.length - 1)];

  return (
    <HeaderLevelContext.Provider
      value={{
        currentLevel: initialLevel,
        nextLevel,
      }}
    >
      {children}
    </HeaderLevelContext.Provider>
  );
};

export default HeaderLevelProvider;
